import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { memo, useEffect, useState } from "react";

export const SegmentNameInput = memo(function SegmentNameInput({
  value,
  onChange,
  readonly,
  placeholder,
}: {
  value: string | undefined;
  onChange: (name: string | undefined) => void;
  readonly?: boolean;
  placeholder?: string;
}) {
  const { t } = useTranslation();
  // Commit on blur, not per keystroke: committing re-renders the inspector,
  // which reloads async condition dropdowns and steals focus from this input.
  const [localValue, setLocalValue] = useState(value ?? "");

  useEffect(() => {
    setLocalValue(value ?? "");
  }, [value]);

  const handleChange = useHandler((val: string) => {
    setLocalValue(val);
  });

  const handleBlur = useHandler(() => {
    onChange(localValue || undefined);
  });

  return (
    <RedoTextInput
      label={t("Name")}
      onBlur={handleBlur}
      placeholder={placeholder ?? t("Segment")}
      setValue={handleChange}
      state={readonly ? "readonly" : "default"}
      value={localValue}
    />
  );
});
